import { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import imgStepGray from "../../assets/images/load_step_gray.webp"
import imgStepGreen from "../../assets/images/load_step_green.webp"
import s from './LoadScreen.module.css'

const LoadScreen: React.FC = () => {
    const navigate = useNavigate();
    const [count, setCount] = useState(0);
    const {isLoaded} = useSelector((state: RootState) => state.game);

    const user = useSelector((state: RootState) => state.game.user);
    useEffect(() => {
        if(!isLoaded) return;

        const timer = setTimeout(() => {
            if(user.active_state >= 14) {
                navigate("/main");
            } else if(user.active_state >= 1) {
                navigate("/social");
            }
            else navigate("/social");
        }, 4000);

        return () => clearTimeout(timer);

    }, [isLoaded, user.active_state, navigate]);


    useEffect(() => {
        const duration = 4000;
        const updateInterval = 100;
        const steps = duration / updateInterval;
        const increment = 100 / steps;

        const interval = setInterval(() => {
            setCount((prev) => {
                if (prev >= 100) {
                    clearInterval(interval);
                    return 100;
                }
                return prev + increment;
            });
        }, updateInterval);

        return () => clearInterval(interval);
    }, []);

    return (

        <div className={s.container}>
            <button className={s.buttonLoad} onClick={() => { }} type="button">
                <p className={s.text}>AIRDROP INCOMING!</p>
            </button>

            <div className={s.loadContainer}>
                <p className={s.textLoading}>
                    Loading - <span className={s.textCount}>{String(Math.round(count))}</span>%
                </p>
                <div className={s.line} ></div>
                <div className={s.footprintContainer}>
                    <img className={`${s.footprint} ${s.gray}`} src={imgStepGray} alt="step" />
                    <img className={`${s.footprint} ${s.green}`} src={imgStepGreen} alt="step" />
                </div>
            </div>
        </div>
    )
}

export default LoadScreen